export const MAX_RETRIES = 3;
